export const UTM_PARAM_KEYS = {
  campaign: 'utm_campaign',
  medium: 'utm_medium',
  source: 'utm_source',
  content: 'utm_content',
  term: 'utm_term',
};

export const UTM_PARAM_VALUES = {
  dkpnIframe: 'doorpakken-iframe',
  dkpn: 'doorpakken',
  succes: 'succes',
  abnAmro: 'abnamro',
  referral: 'referral',
  tikkieCheck: 'Tikkie_check',
};
